import { render, staticRenderFns } from "./CheckoutModal.vue?vue&type=template&id=1573328c&"
import script from "./CheckoutModal.vue?vue&type=script&lang=js&"
export * from "./CheckoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckoutModal.vue"
export default component.exports